exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mp-context-menu mp-drop-menu {\n  position: absolute;\n  z-index: 7000;\n}\n.mp-context-menu mp-drop-menu mp-items-menu {\n  max-height: 340px;\n  min-width: 160px;\n}\n.mp-context-menu .context-menu-search-wrapper {\n  border-bottom: 1px solid #f6f6f6;\n  padding: 8px;\n}\n.mp-context-menu .context-menu-search-wrapper mp-input {\n  width: 100%;\n}\n", ""]);

// exports
